// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__26hE3","icon":"SortAdornment_icon__ZRAV2","up":"SortAdornment_up__3rRcO","down":"SortAdornment_down__3-70z","active":"SortAdornment_active__GPkGJ"};